import { render, staticRenderFns } from "./customerDetailsDrawer.vue?vue&type=template&id=ea2dcbe2&scoped=true"
import script from "./customerDetailsDrawer.vue?vue&type=script&lang=js"
export * from "./customerDetailsDrawer.vue?vue&type=script&lang=js"
import style0 from "./customerDetailsDrawer.vue?vue&type=style&index=0&id=ea2dcbe2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2dcbe2",
  null
  
)

export default component.exports